import React from 'react'

import { Trash2Icon } from 'lucide-react'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { HASH_SYMBOL } from '~/client/src/shared/utils/usefulStrings'

import CalendarLinkInputStore from '../CalendarLinkInput.store'

interface IProps {
  store: CalendarLinkInputStore
}

const SUBSCRIPTION_ROW =
  'tw:grid tw:grid-cols-[40px_150px_320px_100px] tw:items-center tw:border-0 tw:border-b tw:border-solid tw:border-border'

@observer
export default class CalendarSubscriptions extends React.Component<IProps> {
  public render(): JSX.Element {
    const { subscriptions } = this.store

    if (!subscriptions?.length) {
      return (
        <div className="tw:mt-7.5 tw:px-7.5 tw:text-body-sm tw:text-muted-foreground">
          {Localization.translator.youDontHaveAnySubscriptionsYet}
        </div>
      )
    }

    return (
      <div className="tw:mt-5 tw:flex tw:w-full tw:flex-col tw:px-7.5">
        <div className="tw:mb-10 tw:text-body-sm tw:text-muted-foreground">
          {Localization.translator.youSubscribedToNExternalProjects(
            subscriptions.length,
          )}
        </div>
        {this.renderSubscriptionsTable()}
      </div>
    )
  }

  private renderSubscriptionsTable(): JSX.Element {
    return (
      <div className="tw:flex tw:flex-col">
        <div
          className={`${SUBSCRIPTION_ROW} tw:pb-2.5 tw:text-label-sm tw:text-muted-foreground`}
        >
          <div>{HASH_SYMBOL}</div>
          <div>{Localization.translator.sharedProjectName}</div>
          <div>{Localization.translator.inviteLink}</div>
          <div>{Localization.translator.visibility}</div>
        </div>
        {this.store.subscriptions.map((subscription, index) => (
          <div key={subscription.id} className={`${SUBSCRIPTION_ROW} tw:py-1`}>
            <div>{index + 1}.</div>
            <div>{subscription.tenantCalendarEndpoint.split('/').at(-2)}</div>
            <div className="tw:flex tw:items-center">
              <div className="tw:w-55 tw:truncate">
                {subscription.tenantCalendarEndpoint}
              </div>
              <Button
                variant="primary-outline"
                className="tw:ml-2.5"
                onClick={() =>
                  this.store.copyLinkToClipboard(
                    subscription.tenantCalendarEndpoint,
                  )
                }
              >
                {Localization.translator.copy}
              </Button>
            </div>
            <div className="tw:flex tw:items-center">
              <Button
                variant="destructive-ghost"
                size="icon"
                aria-label={Localization.translator.deleteSubscription}
                onClick={() =>
                  this.store.setIsRemoveSubscriptionDialogShown(
                    true,
                    subscription.id,
                  )
                }
              >
                <Trash2Icon />
              </Button>
            </div>
          </div>
        ))}
      </div>
    )
  }

  private get store(): CalendarLinkInputStore {
    return this.props.store
  }
}
